import { buildPaginatedParams } from './utils';
import {
  ShopRequestCommunicationLogFilePayload,
  ShopRequestCommunicationLogPayload,
} from '../components/MysteryShopping/types';
import axios from '../config/axiosPrivate';
import { CommunityActivityType, PaginatedCommunityActivitiesType } from '../types/communities';

type GetActivitiesParams = {
  nextPageUrl?: string | null;
  page?: number;
  shop_request_id?: number;
};

export const getActivities = async (
  communityId: number,
  params?: GetActivitiesParams
): Promise<PaginatedCommunityActivitiesType> => {
  const response = await axios.get(`/activities/community/${communityId}`, {
    params: buildPaginatedParams(params),
  });
  return response.data;
};

export const createShopRequestCommunicationLog = async (
  communityId: number,
  payload: ShopRequestCommunicationLogPayload
) => {
  const response = await axios.post(`/activities/community/${communityId}/manual-log`, payload);
  return response.data;
};

export const updateShopRequestCommunicationLogActivity = async (
  communityId: number,
  activityId: number,
  payload: { files: ShopRequestCommunicationLogFilePayload[] }
): Promise<CommunityActivityType> => {
  const response = await axios.patch(`/activities/community/${communityId}/activities/${activityId}`, payload);
  return response.data;
};
